import { useAuth } from '../App';

/**
 * RBAC hook — centralised permission helper.
 * Roles: admin (super admin), investor (manager view, no API keys), closer, salesperson.
 */
export function useRBAC() {
  const { user } = useAuth();
  const role = user?.role || 'salesperson';
  const isAdmin = role === 'admin';
  const isInvestor = role === 'investor';
  const isManager = isAdmin || isInvestor;
  const isSuperAdmin = isAdmin;

  const PERMISSIONS = {
    // Navigation / page access
    view_admin_panel: ['admin', 'investor'],
    view_crm_integrations: ['admin', 'investor'],
    view_all_analytics: ['admin', 'investor'],
    view_hiring: ['admin', 'investor'],
    view_prove_it: ['admin', 'investor'],

    // Super-admin only (API keys & billing config)
    manage_api_keys: ['admin'],

    // Lead operations
    delete_lead: ['admin'],
    bulk_delete_leads: ['admin'],

    // Lead Mining
    create_mining_job: ['admin', 'investor'],
    delete_mining_job: ['admin'],

    // User & system management
    manage_users: ['admin'],
    manage_credits: ['admin'],
    view_system_health: ['admin', 'investor'],

    // Campaigns / SMS
    create_campaign: ['admin', 'investor', 'salesperson'],
    send_campaign: ['admin', 'investor', 'salesperson'],

    // Credits
    buy_credits: ['admin', 'salesperson'],
    grant_credits: ['admin'],
  };

  const can = (action) => {
    const allowed = PERMISSIONS[action];
    if (!allowed) return true;
    return allowed.includes(role);
  };

  const requireAdmin = (fallback = null) => (isAdmin ? null : fallback);

  return { isAdmin, isInvestor, isManager, isSuperAdmin, role, can, requireAdmin };
}
